module.exports = __webpack_public_path__ + "static/media/lokk_logo.89974d13.svg";